import { createAction } from 'redux-actions';

import { APP_LOADED, TransactionTypes } from '../../../settings/settings';

export const loadApplication = (actions) => {
  return (dispatch) => {
    Promise.all([
      actions.getPersonalInformation(),
      dispatch(actions.getProductTypes()),
      dispatch(actions.getRMDLimits()),
      dispatch(actions.getUserFunds(TransactionTypes.SELL)),
    ]).then(
      () => {
        actions.getUserMessages();
        dispatch(createAction(`${APP_LOADED}_FULFILLED`)(true));
        dispatch(actions.getPendingTransactions());
      },
      () => {
        const action = createAction(`${APP_LOADED}_REJECTED`)(true);
        dispatch(action);
      }
    );
  };
};
